import { Outlet } from 'react-router-dom';
import DashboardLayout from '../../layouts/DashboardLayout';
import { LayoutDashboard, ClipboardList } from 'lucide-react';

const juryMenuItems = [
  {
    title: 'Dashboard',
    to: '/jury-dashboard',
    icon: <LayoutDashboard className="w-4 h-4" />,
    end: true,
  },
  {
    title: 'Review Queue',
    to: '/jury-dashboard/review-queue',
    icon: <ClipboardList className="w-4 h-4" />,
  },
];

export function Layout() {
  return (
    <DashboardLayout menuItems={juryMenuItems}>
      <Outlet />
    </DashboardLayout>
  );
}
